export default __webpack_public_path__ + "static/media/company_duotone.cdc30e39.svg";